import React from 'react';
import { useActsAsEmployee } from '@/hooks/useActsAsEmployee';
import EmployeeAppraisalEditor from './components/appraisal/EmployeeAppraisalEditor';
import ManagerAppraisalEditor from './components/appraisal/ManagerAppraisalEditor';

function AppraisalEditorRouter() {
  // An admin who is also an employee fills in their own appraisal from My
  // workspace, and reviews their team's from Performance.
  const isEmployee = useActsAsEmployee();
  
  if (isEmployee) {
    return <EmployeeAppraisalEditor />;
  }
  
  return <ManagerAppraisalEditor />;
}

export default AppraisalEditorRouter;
